export const Images = {
  emptyDataTable:
    'https://res.cloudinary.com/hbrrdozyj/image/upload/v1616081892/cliengo/history.svg',
  emptyDataTableFilter:
    'https://res.cloudinary.com/hbrrdozyj/image/upload/v1616081892/cliengo/search.svg',
  messagesErrorInConversation:
    'https://res.cloudinary.com/hbrrdozyj/image/upload/v1637941257/Bot_eimqv9.svg',
};

export const CHANNELS = [
  {
    id: 'facebook',
    name: 'Facebook',
  },
  {
    id: 'web',
    name: 'Web',
  },
  {
    id: 'whatsapp',
    name: 'Whatsapp',
  },
];
export const CONDITIONS = [
  {
    id: 'lead',
    name: 'Lead',
  },
  {
    id: 'intervened',
    name: 'Intervened',
  },
];

export const FORMATS_DATE_TIME = {
  en: 'MM/DD/YYYY, h:mm a',
  es: 'DD/MM/YYYY, h:mm a',
  pt: 'DD/MM/YYYY, h:mm a',
};

export const LOCAL_TAGS_KEY = 'cliengo_local_tags';
